import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

interface StatCardProps {
  value: string; // Final value to display as a string
  label: string;
  color: string;
}

const StatCard: React.FC<StatCardProps> = ({ value, label, color }) => {
  const [currentValue, setCurrentValue] = useState(0); // Numeric current value for animation

  useEffect(() => {
    const targetValue = parseFloat(value.replace(/[^\d.]/g, "")); // Extract numeric value
    const increment = Math.ceil(targetValue / 100); // Define the increment step
    const interval = setInterval(() => {
      setCurrentValue((prev) => {
        if (prev + increment >= targetValue) {
          clearInterval(interval);
          return targetValue;
        }
        return prev + increment;
      });
    }, 80); // Speed of the animation

    return () => clearInterval(interval);
  }, [value]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        borderRadius: 2,
        backgroundColor: "#172554",
        padding: 2,
        height: 160,
        width: "100%",
        textAlign: "center",
      }}
    >
      <Typography variant="h4" fontWeight="bold" color="white">
        {value.includes("%") || value.includes("+") || value.includes("/")
          ? `${currentValue}${value.replace(/[0-9.]/g, "")}` // Add non-numeric parts (%, +, /)
          : currentValue}
      </Typography>
      <Typography variant="body1" color="#f97316">
        {label}
      </Typography>
    </Box>
  );
};

const Stats: React.FC = () => {
  const statsData = [
    { value: "10K+", label: "Assignments Delivered", color: "rgba(200, 250, 205, 0.5)" },
    { value: "98%", label: "On-Time Delivery", color: "rgba(200, 230, 255, 0.5)" },
    { value: "30%", label: "Client Referrals", color: "rgba(220, 225, 255, 0.5)" },
    { value: "99%", label: "Average Rating", color: "rgba(240, 220, 255, 0.5)" },
  ];

  return (
    <Box sx={{ maxWidth: "1000px", mx: "auto", my: 4, px: 2 }} className="component">
      <Grid container spacing={2}>
        {statsData.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <StatCard value={stat.value} label={stat.label} color={stat.color} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Stats;
